<template>
	<paper-page>
		<div :class="$style.wrapper">
			<h1 class="h1 align-center">Linked Bingo Reports</h1>
			<br />
			<ul class="grid-1">
				<paper-list-item v-for="site in sites" :key="site.subdomain" class="card content" :href="'https://' + site.subdomain">
					<template #indicator>
						<img :src="site.subdomain + '/favicon.ico'" />
					</template>
					<template #default>
						<h2 class="h3">{{ site.friendlyName }}</h2>
						<div class="s1">{{ site.location }}</div>
						<div class="overline">{{ site.subdomain }}</div>
					</template>
				</paper-list-item>
			</ul>
		</div>
	</paper-page>
</template>

<script>
import PaperPage from '@jamescoyle/paper-vue/core/paper-page'
import PaperListItem from '@jamescoyle/paper-vue/component/paper-list-item'

import Ajax from 'ajax'

export default {
	components: {
		PaperPage,
		PaperListItem,
	},

	data: () => ({
		sites: [],
	}),

	created() {
		Ajax.request('api/data/portaldata.php')
			.as('json')
			.then((result) => {
				this.sites = result.data
			})
	},
}
</script>

<style lang="scss" module>
.wrapper {
	width: 32rem;
	margin: var(--increment) auto;
}
</style>
